/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ rir: NonNullable<unknown> }} Quick_Workout_Load_FeelInputs */

const en_us2_quick_workout_load_feel = /** @type {(inputs: Quick_Workout_Load_FeelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Load: pick one that leaves ${i?.rir} reps in reserve`)
};

const pt_br2_quick_workout_load_feel = /** @type {(inputs: Quick_Workout_Load_FeelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Carga: escolha uma que deixe ${i?.rir} repetições sobrando`)
};

const es_419_quick_workout_load_feel = /** @type {(inputs: Quick_Workout_Load_FeelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Peso: elige uno que te deje ${i?.rir} repeticiones en reserva`)
};

const pt_pt2_quick_workout_load_feel = /** @type {(inputs: Quick_Workout_Load_FeelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Carga: escolhe uma que deixe ${i?.rir} repetições de reserva`)
};

const fr_fr2_quick_workout_load_feel = /** @type {(inputs: Quick_Workout_Load_FeelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Charge : choisis-en une qui laisse ${i?.rir} répétitions en réserve`)
};

const de_de2_quick_workout_load_feel = /** @type {(inputs: Quick_Workout_Load_FeelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Gewicht: wähle eines, bei dem ${i?.rir} Wdh. im Tank bleiben`)
};

const it_it2_quick_workout_load_feel = /** @type {(inputs: Quick_Workout_Load_FeelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Carico: scegline uno che ti lasci ${i?.rir} ripetizioni di riserva`)
};

/**
* | output |
* | --- |
* | "Load: pick one that leaves {rir} reps in reserve" |
*
* @param {Quick_Workout_Load_FeelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const quick_workout_load_feel = /** @type {((inputs: Quick_Workout_Load_FeelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quick_Workout_Load_FeelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_quick_workout_load_feel(inputs)
	if (locale === "es-419") return es_419_quick_workout_load_feel(inputs)
	if (locale === "pt-PT") return pt_pt2_quick_workout_load_feel(inputs)
	if (locale === "fr-FR") return fr_fr2_quick_workout_load_feel(inputs)
	if (locale === "de-DE") return de_de2_quick_workout_load_feel(inputs)
	if (locale === "it-IT") return it_it2_quick_workout_load_feel(inputs)
	return en_us2_quick_workout_load_feel(inputs)
});
export { quick_workout_load_feel as "quick-workout.load_feel" }